import React from 'react';
import { formatDistance } from 'date-fns';
import Stack from '@/components/v3/Stack';
import Tag from '@/components/Tag';
import AuditLogSliderContent from './AuditLogSliderContent';

const AuditLogSliderItem = ({ auditLog }) => {
  const date = auditLog.createdOn ? `${formatDistance(new Date(), new Date(auditLog.createdOn))} ago` : '';
  const blocks = auditLog.meta?.blocks || [];

  return (
    <div key={auditLog.id} className="audit-log-item">
      <div className="audit-log-item-header">
        <div className="created-by">
          <Stack direction="vertical" gap={6}>
            <Stack justify="start" gap={6}>
              <strong className="created-by-name">{auditLog.createdBy.name}</strong>
            </Stack>
          </Stack>
        </div>
        {date && <Tag>{date}</Tag>}
      </div>
      <div className="audit-log-item-body">
        <AuditLogSliderContent blocks={blocks} />
      </div>
    </div>
  );
};

export default AuditLogSliderItem;
